/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-item-selector{display:block}app-item-selector .item-selector .swiper-slide{position:relative;height:45px;text-align:center;line-height:48px;font-weight:600;color:#000;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:row;flex-direction:row}app-item-selector .item-selector .swiper-button-prev{background:url(/assets/images/previous-arrow.png) center no-repeat}app-item-selector .item-selector .swiper-button-next{background:url(/assets/images/previous-arrow.png) center no-repeat;-ms-transform:scaleX(-1);transform:scaleX(-1)}"];
export { styles as styles };
